import { render, staticRenderFns } from "./SubmissionBatchControls.vue?vue&type=template&id=209dc4ec&scoped=true&"
import script from "./SubmissionBatchControls.vue?vue&type=script&lang=js&"
export * from "./SubmissionBatchControls.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionBatchControls.vue?vue&type=style&index=0&id=209dc4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209dc4ec",
  null
  
)

export default component.exports